import { Component, OnInit, Output, EventEmitter, Renderer2 } from '@angular/core';
import templateString from './candidateTypeChangeOrder.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { EnvironmentService } from '../../../environment.service';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString, host: {'forUniqueComponentId': 'o;eiajh;ewfjo'}
})
export class CandidateTypeChangeOrderComponent implements OnInit {
    @Output() action = new EventEmitter();
    
    public originalCandidateTypes: any;
    
    public candidateTypes: any;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2,
        private environmentService: EnvironmentService
    ) { 
        this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
    }

    ok() {
        this.http.post("candidate_types/update_order", { candidate_type_ids: this.candidateTypes.map(function(x) { return x.id; }) }).subscribe(() => {
            this.action.emit(true);
            this.bsModalRef.hide();
		});
    }

    cancel() {
        this.bsModalRef.hide();
    };

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.candidateTypes, event.previousIndex, event.currentIndex);
    }

    ngOnInit() {
        this.candidateTypes = JSON.parse(JSON.stringify(this.originalCandidateTypes));
    }
}
